import { render } from "./SliderSelector.vue?vue&type=template&id=5d6b6716&scoped=true"
import script from "./SliderSelector.vue?vue&type=script&lang=js"
export * from "./SliderSelector.vue?vue&type=script&lang=js"

import "@/assets/css/slider.css?vue&type=style&index=0&lang=css"
import "./SliderSelector.vue?vue&type=style&index=1&id=5d6b6716&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5d6b6716"

export default script